import { type FloorPriceChangesProps } from '@app/client/resources/marketplace/types';

import { useGetFloorPriceChangesData, useGetWishlistSummaryData } from './dataSources';

type UseWishlistGetPortfolioValueProps = {
    slug?: string;
    disabled?: boolean;
};
export const useWishlistGetPortfolioValue = ({ slug, disabled }: UseWishlistGetPortfolioValueProps) => {
    const date = new Date();
    date.setDate(date.getDate() - 1);

    /////////////////////// get summary data
    const {
        data: summaryData,
        isLoading: summaryIsLoading,
        isFetching: summaryIsFetching,
        isError: isSummaryError,
    } = useGetWishlistSummaryData({ providedSlug: slug || '', disabled });

    /////////////////////// construct floorPriceChanges

    const floorPriceChanges: FloorPriceChangesProps = { date };

    summaryData?.portfolio_summary?.interested_tokens?.forEach((tokensData) => {
        if (!floorPriceChanges['contracts']) floorPriceChanges['contracts'] = [];
        floorPriceChanges.contracts?.push({
            contract: tokensData.contract,
            tokens: tokensData.tokens,
        });
    });
    summaryData?.portfolio_summary?.interested_collections?.forEach((collectionsData) => {
        if (!floorPriceChanges['slugs']) floorPriceChanges['slugs'] = [];
        floorPriceChanges.slugs?.push(collectionsData.slug);
    });

    /////////////////////// fetch floor price changes
    const {
        totalFloorPriceChanges,
        isLoading: floorPriceChangeIsLoading,
        isFetching: floorPriceChangeIsFetching,
        isError: isFloorPriceChangeError,
    } = useGetFloorPriceChangesData({ slug, floorPriceChanges, disabled: !summaryData || disabled });

    /////////////////////// get % change
    const percentageChange = totalFloorPriceChanges
        ? ((totalFloorPriceChanges?.current - totalFloorPriceChanges?.past) * 100) / totalFloorPriceChanges?.current
        : 0;

    /////////////////////// set response
    const isLoading = summaryIsLoading || floorPriceChangeIsLoading;
    const isFetching = summaryIsFetching || floorPriceChangeIsFetching;
    const isError = isFloorPriceChangeError || isSummaryError;
    return { totalFloorPriceChanges, percentageChange, isLoading, isError, isFetching };
};
